/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function PipetteIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="pipette"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M17.321 5.233C17.907 4.647 18.857 4.647 19.442 5.233C20.028 5.818 20.028 6.768 19.442 7.354L18.793 8.003C18.234 8.562 18.234 9.469 18.793 10.028C19.32 10.555 19.355 11.398 18.874 11.966L18.834 12.014C18.267 12.684 17.248 12.726 16.628 12.106L12.569 8.047C11.949 7.427 11.991 6.408 12.661 5.841L12.709 5.801C13.277 5.32 14.12 5.355 14.647 5.882C15.206 6.441 16.113 6.441 16.672 5.882L17.321 5.233Z" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M13.184 8.662L5.777 16.07C5.14 16.706 5.008 17.69 5.453 18.472C5.631 18.785 5.89 19.044 6.203 19.222C6.985 19.667 7.969 19.535 8.605 18.898L16.013 11.491" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M5.724 18.951L4.558 20.117" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
